module.exports = __webpack_public_path__ + "static/11-76632281b8fb3f72c859bba8d5191614.jpg";